import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import styles from './contact.module.css';

function ContactForm() {
    const form = useRef();
    const [status, setStatus] = useState("");

    const time = new Date().toISOString().split('T')[0];

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            "service_w7qwo2u",
            "template_cekk8a9",
            form.current,
            "ueDfAFpH1hzOjS5d5"
        ).then(
            (result) => {
                console.log(result.text);
                setStatus("Message sent successfully!");
                form.current.reset();
            },
            (error) => {
                console.log(error.text);
                setStatus("Something went wrong. Please try again.");
            }
        );
    };

    return (
        <div className={styles.contactPage}>
            <img src="/images/Poolhouse/007.jpg" alt="Overkapping" />
            <div className={styles.container}>
                <div className={styles.columnTitle}>
                    <h2>Contacteer ons</h2>
                    <div className={styles.underline}></div>
                </div>
            <form ref={form} onSubmit={sendEmail} className={styles.contactForm}>
                <input type="hidden" name="time" value={time}/>
                <div className={styles.formRow}>
                    <label>Naam*</label>
                    <input type="text" name="name" required />
                </div>
                <div className={styles.formRow}>
                    <label>E-mail*</label>
                    <input type="email" name="email" required />
                </div>
                <div className={styles.formRow}>
                    <label>Telefoonnummer</label>
                    <input type="text" name="Phone_number" />
                </div>
                <div className={styles.formRow}>
                    <label>Bericht*</label>
                    <textarea name="message" required />
                </div>
                <div className={styles.formRow}>
                    <span className={styles.formLabelSpace}></span>
                    <button type="submit">Verstuur</button>
                </div>
            </form>
            {status && <p>{status}</p>}
            </div>
        </div>
    );
}

export default ContactForm;
